import { useEffect, useState } from 'react';

const DEFAULT_PAGE_TITLE = 'Xvantage';

/** updatePageTitle: Sets page title for the consuming View component as the input string.
 * For setting page title on iFramed pages, see:
 * https://imonline.atlassian.net/wiki/spaces/DigitalT/pages/3070820435/X4C+Page+Titles#iFramed-Pages */
export function usePageTitle() {
  const [pageTitle, setPageTitle] = useState(DEFAULT_PAGE_TITLE);

  const updatePageTitle = (newPageTitle: string) => {
    if (newPageTitle && pageTitle !== newPageTitle) {
      setPageTitle(newPageTitle);
    }
  };

  useEffect(() => {
    document.title = pageTitle;
    return () => {
      document.title = DEFAULT_PAGE_TITLE;
    };
  }, [pageTitle]);

  return { pageTitle, updatePageTitle };
}
